<!-- Modal 调整成员部门  -->
<template>
  <el-dialog
    width="460px"
    :visible.sync="nowVisible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <CardHeader name="调整成员部门" @closeDrawer="clickCancel"></CardHeader>

    <div class="addRole">
      <div class="tree">
        <el-tree
          ref="tree"
          class="input_input"
          :data="organizationTree"
          :props="defaultProps"
          node-key="deptId"
          :check-strictly="true"
          :expand-on-click-node="false"
          :check-on-click-node="true"
          default-expand-all
          show-checkbox
        >
        </el-tree>
      </div>

      <el-button class="okbtn" type="primary" @click="onSubmit">
        确定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { reUserDept, reUserDeptBatch, authdeptlist } from "../../../api/api";
import CardHeader from "../../../components/cardHeader/index.vue";
export default {
  name: "changeDeptModal",
  props: {
    visible: {
      type: Boolean,
    },
    obj: {
      type: Object,
      value: {},
    },
  },
  components: { CardHeader },
  data() {
    return {
      nowVisible: this.visible,
      nowObj: this.obj,
      // 树结构
      organizationTree: [],
      defaultProps: {
        children: "children",
        label: "deptName",
      },
    };
  },
  watch: {
    async visible(val) {
      this.nowVisible = val;
      if (val) {
        this.getTree();
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
    },
    obj(val) {
      this.nowObj = val;
    },
  },
  methods: {
    // 获取组织树
    async getTree() {
      let params = {
        deptPId: this.$props.obj.deptId,
      };
      let res = await authdeptlist(params);

      if (res.code == 200) {
        this.organizationTree = res.data;

        // 回显部门
        if (this.$props.obj.type === "single") {
          this.$refs.tree.setCheckedKeys(this.$props.obj.chooseDept);
        }
      }
    },
    // modal
    clickCancel() {
      this.$emit("closeModal", {
        type: this.nowObj.type,
        actionType: "cancel",
      });
    },
    async onSubmit() {
      const nowDepts = this.$refs.tree.getCheckedKeys();

      if (!nowDepts.length) {
        this.$notify.info({
          title: "消息",
          message: "请至少选择一个部门",
        });
        return;
      }

      let params = {
        single: {
          companyId: this.organizationTree[0].companyId,
          userId: this.$props.obj.userIds,
          deptIds: nowDepts,
        },
        multiple: {
          companyId: this.organizationTree[0].companyId,
          userIds: this.$props.obj.userIds,
          deptIds: nowDepts,
        },
      };
      let paramsObj = {
        single: reUserDept,
        multiple: reUserDeptBatch,
      };

      let res = await paramsObj[this.$props.obj.type](
        params[this.$props.obj.type]
      );
      if (res.code == 200) {
        this.$store.commit("SET_Refresh_Organize");
        this.$store.commit("SET_Refresh_UserList");
        this.$store.commit("SET_Refresh_User_Msg");

        this.$emit("closeModal", {
          type: this.nowObj.type,
          actionType: "confirm",
        });

        this.$notify.success({
          title: "成功",
          message: res.msg,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.addRole {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  box-sizing: border-box;
  .tree {
    width: 90%;
    height: 25rem;
    overflow-y: auto;
  }
  .okbtn {
    margin-top: 1rem;
  }
}
</style>